const ShareService = {

  isMobile() {
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  },

  viaWhatsapp(url, playlistName) {
    if (!this.isMobile()) return;
    const whatsappUrl = `whatsapp://send?text=${encodeURIComponent(`${this.getMessage(playlistName)} ${url}`)}`;
    window.location.href = whatsappUrl;
  },

  getMessage(playlistName) {
    return `Hey, ich bin dabei ${playlistName ? `die ${playlistName}` : 'eine'} Playlist für meine Party zu erstellen. Mit Jukie kannst du ganz einfach mitmachen und deine Lieblingslieder hinzufügen.`;
  },

};

export default ShareService;
